import { useModal, useRouter } from '@application/utils';
import { DogBreederApplicationStatus } from '@gql/graphql';
import type { MtApplicationsBreederRejectModalFormValues } from '@presentation/components';
import { useFormik } from 'formik';
import { useCallback } from 'react';
import { useDeleteApplication } from './api/useDeleteApplication';

export const useSharedApplicationBreeder = (applicationId: number | undefined) => {
  const { navigateToRoute } = useRouter();

  const { deleteApplication, deleteApplicationLoading } = useDeleteApplication();
  const { show: showDeleteModal, modal: deleteModal, close: closeDeleteModal } = useModal();

  const deleteModalForm = useFormik<MtApplicationsBreederRejectModalFormValues>({
    initialValues: {
      reason: '',
    },
    onSubmit: async (values) => {
      if (!applicationId) throw new Error();
      await deleteApplication(applicationId, values.reason);
      closeDeleteModal();
      navigateToRoute('mtApplications');
    },
  });

  const shouldShowOwnAction = useCallback((status: DogBreederApplicationStatus | undefined) => {
    return [
      DogBreederApplicationStatus.WAITING_LIST,
      DogBreederApplicationStatus.CONTACT_AVAILABLE,
    ].includes(status!);
  }, []);

  const shouldShowRefuseAction = useCallback((status: DogBreederApplicationStatus | undefined) => {
    return [
      DogBreederApplicationStatus.CONTACT_AVAILABLE,
      DogBreederApplicationStatus.WAITING_LIST,
    ].includes(status!);
  }, []);

  const shouldShowMessagesAction = useCallback(
    (status: DogBreederApplicationStatus | undefined) => {
      if (!status) return false;
      return [
        DogBreederApplicationStatus.DONE,
        DogBreederApplicationStatus.REJECTED,
        DogBreederApplicationStatus.CONTACT_AVAILABLE,
        DogBreederApplicationStatus.WAITING_LIST,
      ].includes(status);
    },
    [],
  );

  return {
    shouldShowOwnAction,
    shouldShowRefuseAction,
    shouldShowMessagesAction,
    showDeleteModal,
    deleteModalForm,
    deleteModalProps: {
      modal: deleteModal,
      isLoading: deleteApplicationLoading,
    },
  };
};
